import { jsx } from "react/jsx-runtime";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import { validateTidalLicense } from "../../base/index.js";
function ContactPhone(props) {
  return /* @__PURE__ */ jsx(
    ContactPhoneIcon,
    {
      "data-testid": "ContactPhone",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ContactPhone",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
ContactPhone.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "ContactPhone"
};
validateTidalLicense();
export {
  ContactPhone
};
//# sourceMappingURL=ContactPhone.js.map
